import React from 'react';
import { Container, Typography, Grid, Card, CardMedia } from '@mui/material';

const galleryImages = [
  "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=600&q=80",
  "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?auto=format&fit=crop&w=600&q=80",
  "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?auto=format&fit=crop&w=600&q=80",
  "https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?auto=format&fit=crop&w=600&q=80",
];

export default function Gallery() {
  return (
    <Container sx={{ py: 6 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom textAlign="center">Property Gallery</Typography>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {galleryImages.map((img, idx) => (
          <Grid item xs={12} sm={6} md={3} key={idx}>
            <Card sx={{ borderRadius: 2 }}>
              <CardMedia component="img" height="220" image={img} alt={`Gallery ${idx}`} />
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}